import React, {Component} from "react";
import Loading from "../Loading";
import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils, {formatDate, parseDate} from "react-day-picker/moment";
import axios from "axios";

class BankfeeSchedulerVCBUpdate extends Component{

    constructor(props) {
        super(props);
        const ITEM_INITIAL = {
            id: null,
            name: null,
            status: '',
            executeDate:null,
            bankCode: ''
        };
        this.state = {
            item: ITEM_INITIAL,
            errorMessage: '',
            successMessage: '',
            isLoading: false,
            selectedDay: null,
            isEmpty: false,
            isValidDay: false,
            isDisabled: false,
        }
        this.handleDayChange = this.handleDayChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        const ITEM_INITIAL = {
            id: null,
            name: null,
            status: '',
            executeDate:null,
            bankCode: ''
        };
        this.setState({isLoading: true})
        axios.get('/api/bankportal/bankfee/scheduler/vcb/current')
            .then(response => {
                    const selectedDay = parseDate(response?.data?.executeDate, 'DD/MM/YYYY');
                    this.setState({ item: response?.data, selectedDay:selectedDay, errorMessage: '',isLoading: false})
                }
            )
            .catch(error => {
                this.setState({ item: ITEM_INITIAL,errorMessage: error.message,isLoading: false });
                console.error('There was an error!', error);
            })
    }
    handleDayChange(selectedDay, modifiers, dayPickerInput) {
        const input = dayPickerInput.getInput();
        const {item} = this.state;
        const inputDay =  formatDate(selectedDay, 'DD/MM/YYYY');
        console.log('executeDay:'+inputDay)
        item.executeDate = inputDay;
        console.log(item);
        this.setState({
            item: item,
            selectedDay,
            isEmpty: !input.value.trim(),
            isValidDay: typeof selectedDay !== 'undefined',
            isDisabled: modifiers.disabled === true
        });
    }
    handleSubmit() {
        this.setState({isLoading: true})
        const {item} = this.state;
        axios.post('/api/bankportal/bankfee/scheduler', item)
            .then(response => {
                    console.log(response?.data);
                    this.setState({ successMessage:'Cập nhật thành công',errorMessage: '',isLoading: false})
                }
            )
            .catch(error => {
                this.setState({ errorMessage: error.message,isLoading: false });
                console.error('There was an error!', error);
            })
    }
    render() {
        const {item,selectedDay, isLoading,errorMessage, successMessage} = this.state;
        if(isLoading === true) return <Loading />;
        return (
            <div className={'report mx-5'}>
                <div className={'div-center'}>
                    <div className={'content'}>
                        { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
                        { !!successMessage && <div className={"alert alert-info"} role="alert">{ successMessage }</div> }
                        <h2 className={'m-3 text-primary'}>CẬP NHẬT NGÀY CHỐT HOA HỒNG - VCB</h2>
                        <form>
                            <div className={'form-group row'}>
                                <label className={'col-sm-4 col-form-label'}>Ngày chốt báo cáo hoa hồng:</label>
                                <div className="col-sm-18">
                                    <DayPickerInput
                                        value={selectedDay}
                                        onDayChange={this.handleDayChange}
                                        selectedDay={this.state.selectedDay}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        format="DD/MM/YYYY"
                                        placeholder='DD/MM/YYYY'
                                        dayPickerProps={{
                                            selectedDays: selectedDay,
                                            locale: 'vi-VN',
                                            localeUtils: MomentLocaleUtils,
                                        }}
                                        inputProps={{ className: 'form-control' }} />
                                </div>
                            </div>
                            <div className={'form-group row'}>
                                <label className={'col-sm-4'}>Trạng thái</label>
                                <div className={'col-sm-8'}>
                                    <div>
                                        <span>{item?.status}</span>
                                    </div>
                                </div>
                            </div>
                            <div className={"form-group row"}>
                                <div className={"col-sm-10"}>
                                    <button type="button" className={"btn btn-primary"} onClick={this.handleSubmit}>Lưu dữ liệu</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}
export default BankfeeSchedulerVCBUpdate;